var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import * as Cookie from 'tiny-cookie';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isClient } from "../utils";
import { Translate } from "../I18N";

import { Notification } from "../Notifications/components/Notification";

class Cookiepopup extends Component {
  constructor(props) {
    super(props);
    this.state = { cookieExists: !isClient || isClient && Boolean(Cookie.get('cookiepolicy')) };
    this.close = this.close.bind(this);
  }

  close() {
    Cookie.set('cookiepolicy', 1, { expires: 365 * 10 });
    this.setState({ cookieExists: true });
  }

  render() {
    const { cookiepolicy } = this.props;
    const { cookieExists } = this.state;
    if (!cookiepolicy || cookieExists) {
      return /*#__PURE__*/_jsx("div", { className: "alert-wrapper" });
    }

    const message = /*#__PURE__*/
    _jsx(Translate, {}, void 0, "To bring you a better experience, this site uses cookies.");

    return (/*#__PURE__*/
      _jsx("div", { className: "alert-wrapper" }, void 0, /*#__PURE__*/
      _jsx(Notification, { id: "cookiepolicy", removeNotification: this.close, message: message })
      ));

  }
}





const mapStateToProps = (state) => ({
  cookiepolicy: Boolean(state.settings.collection.get('cookiepolicy'))
});

export { Cookiepopup };
export default connect(mapStateToProps)(Cookiepopup);